import React, { FormEvent, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbar from '../../components/common/Navbar';
import { createMatiyariLead } from '../../services/matiyariService';
import bannerSrc from '../../assets/images/image.png';
import './MatiyariPage.css';

const MatiyariPage: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const sanitizedPhone = phone.replace(/[^0-9+\-() ]/g, '');
  const isFormReady = useMemo(
    () => name.trim().length >= 2 && sanitizedPhone.trim().length >= 7,
    [name, sanitizedPhone]
  );

  const handlePhoneChange = (value: string) => {
    setPhone(value.replace(/[^0-9+\-() ]/g, '').slice(0, 20));
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!isFormReady) {
      toast.error('Please enter your name and mobile number.');
      return;
    }

    setSubmitting(true);
    try {
      await createMatiyariLead({
        name,
        phone: sanitizedPhone,
      });
      toast.success('Details saved. Continue with free subscription registration.');
      navigate('/register', {
        state: {
          referralCode: 'MATIYARI',
          source: 'matiyari',
          name: name.trim(),
          phone: sanitizedPhone.trim(),
        },
      });
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Unable to save details. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="matiyari-page">
        <section className="matiyari-hero">
          <div className="matiyari-visual">
            <img
              src={bannerSrc}
              alt="Ameti mein shiksha kranti - Matiyari ki saugaat"
              className="matiyari-banner"
            />
          </div>

          <div className="matiyari-form-panel">
            <span className="matiyari-kicker">MATIYARI Special</span>
            <h1>फॉर्म भरें और निःशुल्क शिक्षा प्राप्त करें</h1>
            <p>
              जनपद वासियों के लिए मटियारी की ओर से विशेष शिक्षा सुविधा। अपना नाम और
              मोबाइल नंबर भरकर free subscription registration आगे बढ़ाएं।
            </p>

            <form className="matiyari-form" onSubmit={handleSubmit}>
              <label htmlFor="matiyari-name">
                Name
                <input
                  id="matiyari-name"
                  type="text"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  placeholder="Enter your name"
                  required
                  minLength={2}
                  maxLength={80}
                  autoComplete="name"
                />
              </label>

              <label htmlFor="matiyari-phone">
                Phone Number
                <input
                  id="matiyari-phone"
                  type="tel"
                  value={phone}
                  onChange={(event) => handlePhoneChange(event.target.value)}
                  placeholder="Enter mobile number"
                  required
                  minLength={7}
                  maxLength={20}
                  autoComplete="tel"
                />
              </label>

              {isFormReady && (
                <button className="matiyari-submit" type="submit" disabled={submitting}>
                  {submitting ? 'Saving...' : 'Go to Free Subscriptions'}
                </button>
              )}
            </form>
          </div>
        </section>
      </main>
    </>
  );
};

export default MatiyariPage;
